<template>
    <div class="sweetalert2-modal">
        <slot v-bind:close="close"></slot>
    </div>
</template>
<script>
import Swal from "sweetalert2";
export default {
    props: {
        showCancelButton: {
            type: Boolean,
            default: true
        },
        showOkButton: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        close() {
            Swal.close();
        }
    },
    async mounted() {
        let target = "body";
        if (document.fullscreenElement) {
            target = document.fullscreenElement;
        }
        let { isConfirmed } = await Swal.fire({
            target,
            html: `<div id="sweetalert2-modal-container"></div>`,
            showCancelButton: this.showCancelButton,

            showConfirmButton: this.showOkButton,
            cancelButtonText: "Cancelar",
            willOpen: () => {
                document
                    .getElementById("sweetalert2-modal-container")
                    .appendChild(this.$el);
            },
            didClose: () => {
                this.$emit("close");
            }
        });
        if (isConfirmed) {
            this.$emit("confirmed");
        }
    }
};
</script>